<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">
                {{ $t("credits.creditsConsumed.title") }}
              </h4>
              <div class="justify-content-end">
                <export-button :data="tableData" fileName="Creditos_Consumidos" />
                <b-button variant="dark" class="spacingButton" @click="back()">Volver </b-button>
              </div>
            </b-row>
            <b-row>
              <div class="table-responsive mb-0 mt-3">
                <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :busy="isBusy"
                  show-empty
                >
                  <template #empty="">
                    <h5 style="text-align: center">
                      {{ $t("request.table.empty") }}
                    </h5>
                  </template>
                  <template #cell(deuda)="row">
                    ${{ getCurrency(row.value) }}
                  </template>
                  <template #cell(ctaCteNroDocto)="row">
                    <a
                        @click="
                      detailView(row.value, {
                        name: 'detalleContrato',
                      })
                    "
                        class="links"
                    >
                      {{ row.value }}
                    </a>
                  </template>
                </b-table>
              </div>
              <!-- Inicio Paginación -->
              <div class="col" v-if="tableData.length">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination
                                    @page-click="changePage"-->
                    <b-pagination
                      class="portal"
                      v-model="currentPage"
                      :per-page="perPage"
                      :total-rows="totalRegister"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import i18n from "@/i18n";
import axios from "@/axios";
import {formatCurrency} from "../../../utils";
export default {
  components: {
    Layout,
    "export-button": ExportButton,
  },
  data() {
    return {
      fields: [
        {
          key: i18n.t("credits.creditsConsumed.table.number.key"),
          label: i18n.t("credits.creditsConsumed.table.number.label"),
        },
        {
          key: i18n.t("credits.creditsConsumed.table.fromDate.key"),
          label: i18n.t("credits.creditsConsumed.table.fromDate.label"),
        },
        {
          key: i18n.t("credits.creditsConsumed.table.toDate.key"),
          label: i18n.t("credits.creditsConsumed.table.toDate.label"),
        },
        {
          key: i18n.t("credits.creditsConsumed.table.consumedAmount.key"),
          label: i18n.t("credits.creditsConsumed.table.consumedAmount.label"),
        },
        {
          key: i18n.t("credits.creditsConsumed.table.pay.key"),
          label: i18n.t("credits.creditsConsumed.table.pay.label"),
        },
      ],
      tableData: [],
      valuePagination: {
        default: 1,
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totalRegister: 1,
      isBusy: false,
    };
  },
  beforeMount(){
    this.getConsumedCredits();
  },
  methods: {
    getConsumedCredits() {
      this.isBusy = true;
      axios
        .get(
          `/${this.$t("credits.creditsConsumed.axios.consumed")}/${
            this.$store.getters["rutEmpresa/cuentaSeleccionada"].value
          }`
        )
        .then((response) => {
          this.tableData = response.data;
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
          this.$bvToast.toast(this.$t("request.error.message").toString(), {
            title: this.$t("request.error.title").toString(),
            variant: "danger",
            solid: true,
          });
        });
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    detailView(id, confRoute) {
      this.$store.dispatch("hideValue/updateId", id);
      this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
      this.$router.push(confRoute);
    },
    back(){
      history.back();
    }
  },
};
</script>
<style>
a {
  cursor: pointer;
  color: blue;
}
.spacingButton{
  margin-left: 1rem;
}
</style>
